import { translate } from '@/domains/core/localization/translate';
export const {
  addToWishlistTitle,
  addToWishlistSubTitle,
  addToWishlistSubTitleRevamp,
  addToWishlistSuccessCta,
  addToWishlistCreateTitle,
  addToWishlistCreateTitleRevamp,
  addToWishlistCreateSubTitle,
  addToWishlistSuccessText,
  addToWishlistFailText,
  deleteFromWishlistFailText,
  addToWishlistLabel,
  returnButtonCta,
  returnButtonRevamp,
  wishlistNameBeyondMaxLimit,
  wishlistRestrictedName
} = translate({
  "addToWishlistTitle": "Add product to wishlist",
  "addToWishlistSubTitle": "Select the wishlist in which you want to add this product",
  "addToWishlistSubTitleRevamp": "Select the list to which you want to add this product.",
  "addToWishlistSuccessCta": "Continue shopping",
  "addToWishlistSuccessText": "product added to",
  "addToWishlistFailText": "An error occurred, the product could not be added to the wishlist. Please try again.",
  "deleteFromWishlistFailText": "An error occurred, the product could not be deleted from the list. Please try again.",
  "addToWishlistCreateTitle": "Add product to new wishlist",
  "addToWishlistCreateTitleRevamp": "Create a new list",
  "addToWishlistCreateSubTitle": "Give a name to your wishlist",
  "addToWishlistLabel": "Add to wishlist",
  "returnButtonCta": "See the wishlist",
  "returnButtonRevamp": "Cancel",
  "wishlistNameBeyondMaxLimit": "The name of your list cannot exceed 200 characters. Please choose another one.",
  "wishlistRestrictedName": "This name is reserved. Please choose another one."
});